import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Spinner from '@atlaskit/spinner/spinner';

const styles = cssMap({
	spinnerContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100vh',
	},
});

export const LivePageLoadingSpinner = (): React.JSX.Element => (
	<Box xcss={styles.spinnerContainer}>
		<Spinner interactionName="live-pages-loading-spinner" size="medium" />
	</Box>
);
